/**
 * 主题预设定义
 * key: 后端返回的 theme 标识符
 * value: CSS 变量映射对象
 */
export const THEME_PRESETS = {
  // 默认主题（蓝色 #0094c6 方案）
  default: {
    // 品牌主色系
    '--color-primary': '#0094c6',
    '--color-primary-hover': '#00a8db',
    '--color-primary-active': '#0080ad',
    '--color-primary-rgb': '0, 148, 198',
    // 文本颜色
    '--color-text-primary': '#264373',
    '--color-text-secondary': '#414652',
    '--color-text-muted': '#A4A9B3',
    // 背景颜色
    '--color-bg-input': '#f1f5f7',
    '--color-bg-layout': '#F6F9FC',
    '--color-bg-page': '#F6F9FC',
    '--color-bg-header': '#FFFFFF',
    // 边框颜色
    '--color-border': '#DDDEE5',
    '--color-border-light': '#E6E9EF',
    // 链接颜色
    '--color-link': '#1F72E8',
  },
    // 品牌 A 主题（橙色 #F57C00 方案）
  brand_a: {
    // 品牌主色系
    '--color-primary': '#F57C00',
    '--color-primary-hover': '#FB8C00',
    '--color-primary-active': '#EF6C00',
    '--color-primary-rgb': '245, 124, 0',
    // 文本颜色
    '--color-text-primary': '#CF4B04',
    '--color-text-secondary': '#4E342E',
    '--color-text-muted': '#8D6E63',
    // 背景颜色
    '--color-bg-input': '#FAF3E6',
    '--color-bg-layout': '#FFF8E1',
    '--color-bg-page': '#FFF8E1',
    '--color-bg-header': '#FFFFFF',
    // 边框颜色
    '--color-border': '#FFE0B2',
    '--color-border-light': '#FFF3E0',
    // 链接颜色
    '--color-link': '#F57C00',
  },
  // 品牌 B 主题（黄色 #F3C81C 方案）
  brand_b: {
    // 品牌主色系
    '--color-primary': '#F3C81C',
    '--color-primary-hover': '#FFB300',
    '--color-primary-active': '#F57F17',
    '--color-primary-rgb': '249, 168, 37',
    // 文本颜色
    '--color-text-primary': '#5D4037',
    '--color-text-secondary': '#4E342E',
    '--color-text-muted': '#8D6E63',
    // 背景颜色
    '--color-bg-input': '#FCFADA',
    '--color-bg-layout': '#FFF9C4',
    '--color-bg-page': '#FFF9C4',
    '--color-bg-header': '#FFFFFF',
    // 边框颜色
    '--color-border': '#FFF176',
    '--color-border-light': '#FFFDE7',
    // 链接颜色
    '--color-link': '#F3C81C',
  },
  // 品牌 C 主题（绿色 #43A047 方案）
  brand_c: {
    // 品牌主色系
    '--color-primary': '#43A047',
    '--color-primary-hover': '#4caf50',
    '--color-primary-active': '#388e3c',
    '--color-primary-rgb': '67, 160, 71',
    // 文本颜色
    '--color-text-primary': '#1b3d1f',
    '--color-text-secondary': '#37474f',
    '--color-text-muted': '#78909c',
    // 背景颜色
    '--color-bg-input': '#f1f8e9',
    '--color-bg-layout': '#f5fbea',
    '--color-bg-page': '#f5fbea',
    '--color-bg-header': '#FFFFFF',
    // 边框颜色
    '--color-border': '#c5e1a5',
    '--color-border-light': '#dcedc8',
    // 链接颜色
    '--color-link': '#388e3c',
  },
  // 品牌 D 主题（青色 #00ACC1 方案）
  brand_d: {
    // 品牌主色系
    '--color-primary': '#00ACC1',
    '--color-primary-hover': '#26C6DA',
    '--color-primary-active': '#00838F',
    '--color-primary-rgb': '0, 172, 193',
    // 文本颜色
    '--color-text-primary': '#004D40',
    '--color-text-secondary': '#37474F',
    '--color-text-muted': '#607D8B',
    // 背景颜色
    '--color-bg-input': '#EDF7F9',
    '--color-bg-layout': '#F0FCFD',
    '--color-bg-page': '#F0FCFD',
    '--color-bg-header': '#FFFFFF',
    // 边框颜色
    '--color-border': '#B2EBF2',
    '--color-border-light': '#E0F7FA',
    // 链接颜色
    '--color-link': '#00ACC1',
  },
  // 品牌 E 主题（紫色 #7B1FA2 方案）
  brand_e: {
    // 品牌主色系
    '--color-primary': '#7B1FA2',
    '--color-primary-hover': '#8E24AA',
    '--color-primary-active': '#6A1B9A',
    '--color-primary-rgb': '123, 31, 162',
    // 文本颜色
    '--color-text-primary': '#4A148C',
    '--color-text-secondary': '#424242',
    '--color-text-muted': '#7E57C2',
    // 背景颜色
    '--color-bg-input': '#F4EDF5',
    '--color-bg-layout': '#F8FBFF',
    '--color-bg-page': '#F8FBFF',
    '--color-bg-header': '#FFFFFF',
    // 边框颜色
    '--color-border': '#E1BEE7',
    '--color-border-light': '#F3E5F5',
    // 链接颜色
    '--color-link': '#7B1FA2',
  },
  // 品牌 F 主题（黑色 #212121 方案）
  brand_f: {
    // 品牌主色系
    '--color-primary': '#212121',
    '--color-primary-hover': '#424242',
    '--color-primary-active': '#000000',
    '--color-primary-rgb': '33, 33, 33',
    // 文本颜色
    '--color-text-primary': '#212121',
    '--color-text-secondary': '#424242',
    '--color-text-muted': '#9E9E9E',
    // 背景颜色
    '--color-bg-input': '#F5F5F5',
    '--color-bg-layout': '#FAFAFA',
    '--color-bg-page': '#FAFAFA',
    '--color-bg-header': '#FFFFFF',
    // 边框颜色
    '--color-border': '#E0E0E0',
    '--color-border-light': '#EEEEEE',
    // 链接颜色
    '--color-link': '#212121',
  },
}

// 默认主题名
export const DEFAULT_THEME = 'default'
